import React, { useContext } from "react";
import { Button, Tooltip } from "antd";
import style from "./index.module.scss";
import { CourseContext } from "../../../../Store";
import { useHistory } from "react-router-dom";
import { BiUndo } from "react-icons/bi";
import useDeviceType from "Utils/useDeviceType";

interface Props {
    title?: string;
    info?: string;
    children?: React.ReactChild;
}
export default function TeamHeader({ children, title, info }: Props) {
    const history = useHistory();
    const { course } = useContext(CourseContext);
    const { isPC } = useDeviceType();

    return (
        <div className={style.root}>
            <div>
                <h1 className={style.title}>
                    <Tooltip
                        title={title ?? course.courseName}
                        placement="bottom">
                        <span className={style.courseTitle}>
                            {title ?? course.courseName}
                        </span>
                    </Tooltip>

                    {isPC && (
                        <Button
                            className={style.back}
                            onClick={() => history.goBack()}>
                            <BiUndo size={16} /> 返回
                        </Button>
                    )}
                </h1>
                {info && <p className={style.info}>{info}</p>}
            </div>
            <div className={style.right}>{children}</div>
        </div>
    );
}
